import {mapState} from 'pinia';
import {useMainStore} from "../state/store";

export default {
    data: function() {
        return {
            vatLabelForRegion: "VAT",
            taxNumberLabelForRegion: "VAT",
            australianLabels: false
        };
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
    },
    methods: {
        setLabels(region) {
            this.australianLabels = region.toUpperCase() === "AU";
            if (this.australianLabels) {
                this.vatLabelForRegion = "GST";
                this.taxNumberLabelForRegion = "ABN";
            }
        }
    },
    mounted() {
        if (typeof this.currentCompany !== "undefined") {
            this.setLabels(this.currentCompany.region);
        }
    }
}
